import { string } from 'prop-types';
import classNames from 'classnames';
import css from './GenericHero.module.css';

const GenericHero = ({ rootClassName = null, className = null, title, subTitle, children }) => {
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.heroContent}>
        <div>
          <h1 className={css.heroMainTitle}>{title}</h1>
          <h2 className={css.heroSubTitle}>{subTitle}</h2>
        </div>
        {children}
      </div>
    </div>
  );
};

GenericHero.propTypes = {
  rootClassName: string,
  className: string,
};

export default GenericHero;
